import { useLang, LANGS } from "@/lib/i18n";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LangSelector() {
  const { lang, setLang } = useLang();
  const current = LANGS.find(l => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-trigger" className="btn-ghost rounded-full text-sm px-3 py-2 flex items-center gap-2">
          <Globe className="size-4" /> <span>{current.flag}</span> <span className="hidden sm:inline">{current.label}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-ink-800 border-white/10 text-white">
        {LANGS.map(l => (
          <DropdownMenuItem key={l.code} data-testid={`lang-opt-${l.code}`}
            className="cursor-pointer focus:bg-white/10"
            onClick={() => setLang(l.code)}>
            <span className="mr-2">{l.flag}</span> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
